function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from "./AllSetStep.module.scss";
import { Link } from 'react-router-dom';
import { Typography, Button } from 'seagull';
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { SuccessPage } from "../../components/SuccessPage";
import { isMobileDevice } from "../../../infra/device";
import { openInNewTabProps, routes } from "../../../constants";
import NewSuccess from "../../assets/newSuccess.svg";
import SetPasswordIcon from "./setPassword.svg";
import InviteIcon from "./invite.svg";
import UpdateProfileIcon from "./updateProfile.svg";
import { useStore, useStoreActions } from "../../../contexts";
import { useResponsive } from "../../contexts";
import { useCobConfig } from "../CobConfigContext";
export default function AllSetStep() {
  const {
    relationship
  } = useCobConfig();
  const {
    logBI
  } = useStoreActions();
  const userInfo = useStore(state => state.userInfo);
  const vendorName = relationship.vendor.name;
  const {
    isDesktop
  } = useResponsive();
  return /*#__PURE__*/React.createElement(SuccessPage, {
    "data-testid": "cob-all-set",
    image: /*#__PURE__*/React.createElement(NewSuccess, null)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    weight: "bold",
    className: styles.desktopTitle
  }, "You're all set!"), /*#__PURE__*/React.createElement("div", {
    className: styles.textBlock
  }, relationship.isSample ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.listItem
  }, "The test agreement is approved."), /*#__PURE__*/React.createElement(Typography, {
    className: styles.listItem
  }, "A confirmation email will be sent to your client upon approval."), /*#__PURE__*/React.createElement(Typography, {
    className: styles.listItem
  }, "You can now go back to Anchor and invite your clients on board.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    className: styles.listItem
  }, "The agreement with ", vendorName, " is now approved", !isMobileDevice && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0and can be viewed\xA0", /*#__PURE__*/React.createElement(ExternalLinkButton, {
    openInNewTab: true,
    href: "/relationship/".concat(relationship.id, "/agreement"),
    testid: "cob-agreement-link"
  }, "in Anchor")), "."), /*#__PURE__*/React.createElement(Typography, {
    className: styles.listItem
  }, "We've emailed you a link to it."), isDesktop && /*#__PURE__*/React.createElement(Typography, {
    className: styles.listItem
  }, "Follow the next steps below to make sure your Anchor account is up-to-date.", !(userInfo !== null && userInfo !== void 0 && userInfo.identityTypes) && ' Start by setting your password.'))), relationship.isSample ? !isMobileDevice && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.nextStepsTitle
  }), /*#__PURE__*/React.createElement(Button, {
    as: Link,
    to: routes.home,
    "data-testid": "cob-test-agreement-link"
  }, "Go to Anchor")) : isDesktop ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: styles.nextStepsTitle
  }, "Recommended next steps"), /*#__PURE__*/React.createElement("div", {
    className: styles.nextStepsRow
  }, !(userInfo !== null && userInfo !== void 0 && userInfo.identityTypes) && /*#__PURE__*/React.createElement("a", _extends({
    className: styles.nextStepBtn,
    href: routes.profile
  }, openInNewTabProps, {
    "data-testid": "cob-set-password",
    onClick: () => logBI(10831)
  }), /*#__PURE__*/React.createElement(SetPasswordIcon, null), /*#__PURE__*/React.createElement(Typography, null, "Set a password")), /*#__PURE__*/React.createElement("a", _extends({
    className: styles.nextStepBtn,
    href: routes.team
  }, openInNewTabProps, {
    "data-testid": "cob-invite-team-members",
    onClick: () => logBI(10830)
  }), /*#__PURE__*/React.createElement(InviteIcon, null), /*#__PURE__*/React.createElement(Typography, null, "Invite your team")), /*#__PURE__*/React.createElement("a", _extends({
    className: styles.nextStepBtn,
    href: routes.businessDetails
  }, openInNewTabProps, {
    "data-testid": "cob-update-profile",
    onClick: () => logBI(10832)
  }), /*#__PURE__*/React.createElement(UpdateProfileIcon, null), /*#__PURE__*/React.createElement(Typography, null, "Update business profile")))) : null);
}